(() => {
  'use strict';
  document.querySelectorAll('[data-preorder-product]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form');
    const variant = form.querySelector('[data-preorder-variant]');
    const button = form.querySelector('[data-preorder-add]');
    const feedback = form.querySelector('[data-preorder-feedback]');
    let busy = false;
    variant.addEventListener('change', () => {
      const option = variant.selectedOptions[0];
      root.querySelector('[data-preorder-price]').textContent = option.dataset.price;
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? 'Currently unavailable' : 'Pre-order now';
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !form.reportValidity()) return;
      busy = true;
      const data = new FormData(form);
      button.disabled = true;
      button.textContent = 'Adding pre-order…';
      form.setAttribute('aria-busy', 'true');
      feedback.textContent = '';
      try {
        const response = await fetch(form.action + '.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add this pre-order. Please try again.');
        window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        feedback.textContent = error instanceof TypeError ? 'Connection interrupted. Check your cart before trying again.' : error.message;
        busy = false;
        button.disabled = variant.selectedOptions[0].dataset.available !== 'true';
        button.textContent = 'Pre-order now';
        form.removeAttribute('aria-busy');
      }
    });
  });
})();
